import React from "react";
import TableContainer from "./TableContainer";

//Import Breadcrumb

const Table = ({ header, data, filter, addButtonTite, addLink, getLengthPage, totalPage, children, open, SetOpen, customToolsBar, checkedAll, setCheckedAll, module, pageSize,
  sort, setSorted, sort_by, setSortBy, submitNewData, categoryList, submitted, creatable, viewable,editable, submittedAdd }) => {
  return (
    <React.Fragment>
      <TableContainer
        columns={header || []}
        data={data || []}
        module={module}
        isPagination={true}
        filter={filter}
        customToolsBar={customToolsBar}
        addButtonTite={addButtonTite}
        addLink={addLink}
        getLengthPage={getLengthPage}
        isBordered={false}
        customPageSize={pageSize}
        totalPage={totalPage}
        children={children}
        open={open}
        SetOpen={SetOpen}
        checkedAll={checkedAll}
        setCheckedAll={setCheckedAll}
        sort={sort}
        setSorted={setSorted}
        sort_by={sort_by}
        setSortBy={setSortBy}
        submitNewData={submitNewData}
        submittedAdd={submittedAdd}
        categoryList={categoryList}
        submitted={submitted} 
        creatable={creatable}
        viewable={viewable}
        editable={editable}
      />
    </React.Fragment>
  );
};

export default Table;
